import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateGeneralPoliticsSchema = z.object({
  product_categories: z.array(optionSchema).optional(),
  commercial_manager: optionSchema.optional(),
  time_zone_id: optionSchema.optional(),
  allows_refunds_via_pos: z.boolean().optional()
})

export type UpdateGeneralPoliticsValidationSchema = z.infer<typeof updateGeneralPoliticsSchema>
